import React, { useContext } from 'react';
import './Path.css';
import { useGlobalState } from 'hooks';

export function PathLite() {
    const [state, dispatch] = useGlobalState();

    function handleClick(newPath) {
        dispatch.setCurrentPath(newPath);
    }

    return (
        <div className="path_main_lite">
            <PathRootLite clickHandler={handleClick}/>
            {state.currentPath.map((folder, index, arr) => (
                <PathComponentLite
                    key={folder + index}
                    folder={folder}
                    index={index}
                    clickHandler={handleClick}
                    path={arr}
                />
            ))}
        </div>
    );
}

function PathRootLite({ clickHandler }) {
    return (
        <div className="path_component_cont_lite"  onClick={() => clickHandler([])}>
            <div className="path_component_lite">ROOT</div>&nbsp;
        </div>
    );
}

function PathComponentLite({ folder, index, clickHandler, path }) {
    return (
        <div className="path_component_cont_lite" onClick={() => clickHandler(path.slice(0, index + 1))}>
            {index < 3 ? '/' : ''}&nbsp;<div className="path_component_lite">{folder.toUpperCase()}</div>&nbsp;
        </div>
    );
}

export function Path() {
    const [state, dispatch] = useGlobalState();

    function handleClick(newPath) {
        dispatch.setCurrentPath(newPath);
    }

    return (
        <div className="path_main">
            <PathRoot clickHandler={handleClick} />
            {state.currentPath.map((folder, index, arr) => (
                <PathComponent
                    key={folder + index}
                    folder={folder}
                    index={index}
                    clickHandler={handleClick}
                    path={arr}
                />
            ))}
        </div>
    );
}

function PathRoot({ clickHandler }) {
    return (
        <div className="path_component_cont" onClick={() => clickHandler([])}>
            <div className="path_component">ROOT</div>&nbsp;
        </div>
    );
}

function PathComponent({ folder, index, clickHandler, path }) {
    return (
        <div className="path_component_cont" onClick={() => clickHandler(path.slice(0, index + 1))}>
            {index < 3 ? '>' : ''}&nbsp;<div className="path_component">{folder.toUpperCase()}</div>&nbsp;
        </div>
    );
}
